module.exports = __webpack_public_path__ + "img/button_EndoTower-Box.90ad61bd.svg";